import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/src/app/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/src/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/src/app/layouts/error.vue").then(m => m.default || m)),
  full: defineAsyncComponent(() => import("/src/app/layouts/full.vue").then(m => m.default || m)),
  print: defineAsyncComponent(() => import("/src/app/layouts/print.vue").then(m => m.default || m))
}